import React from 'react';

const NotificationList = ({ item }) => {
    return <li key={item.id}>
        <h6>Patient: <span>{item.patient_name}</span></h6>
        <h6><span>{item.notification.title}</span></h6>
        <p>{item.notification.body}</p>
    </li>
}
export default NotificationList